import React, { FC } from 'react';

import { Circle } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

interface IHelpCount {
  count?: number;
}

export const HelpCount: FC<IHelpCount> = props => {
  return (
    <Circle
      bg={colorOpacity(customTheme.colors.primary, 0.7)}
      color="white"
      size={6}
    >
      {props.count ?? 0}
    </Circle>
  );
};
